<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <div style="display: flex; justify-content: space-between">
          <div style="">
            <el-button
              v-access:add
              icon="el-icon-plus"
              size="small"
              @click="add"
              :disabled="isloading"
              >新增</el-button
            >
          </div>
          <div style="display: flex">
            <el-input
              style="width: 290px;margin-right: 10px;"
              v-model="searchModel.searchKey"
              clearable
              :placeholder="placeholder"
            />
            <div style="margin-left: 10px">
              <el-button
                size="small"
                icon="el-icon-search"
                type="danger"
                @click="search"
                >查询</el-button
              >
            </div>
          </div>
        </div>
      </div>

      <div>
        <el-tabs
          v-model="activeName"
          type="border-card"
          @tab-click="handleTabsClick"
        >
          <el-tab-pane label="救护员培训活动" name="lifeGuard">
            <el-table
              border
              hightlight-current-row
              style="width: 100%"
              :header-cell-class-name="headerRow"
              :data="lifeGuardModel"
              :max-height="tableMaxHeight()"
              v-loading="isloading"
            >
              <el-table-column
                prop="Title"
                label="培训主题"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <!-- <el-table-column
                prop="StartTime"
                label="开始时间"
                width="140"
                align="center"
              >
                <template slot-scope="scope">
                  {{ (scope.row.StartTime * 1000) | formatDate }}
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                prop="EndTime"
                label="结束时间"
                width="140"
                align="center"
              >
                <template slot-scope="scope">
                  {{ (scope.row.EndTime * 1000) | formatDate }}
                </template>
              </el-table-column> -->
              <el-table-column
                prop="ReviewStatus"
                label="发布状态"
                :formatter="formatterStatus"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="CreateTime"
                label="发布时间"
                width="140"
                align="center"
              >
                <template slot-scope="scope">
                  {{ (scope.row.CreateTime * 1000) | formatDate }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="160" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-access:modify
                    v-if="edit(scope.row)"
                    @click="innerEdit(scope.row)"
                    type="text"
                    size="mini"
                    >编辑</el-button
                  >
                  <el-button
                    v-access:read
                    v-if="!approve(scope.row)"
                    @click="innerRead(scope.row)"
                    type="text"
                    size="mini"
                    >详情</el-button
                  >
                  <el-button
                    v-access:modify
                    v-if="approve(scope.row)"
                    @click="innerReview(scope.row)"
                    type="text"
                    size="mini"
                    >送审</el-button
                  >
                  <el-button
                    v-access:modify
                    v-if="release(scope.row)"
                    @click="innerRelease(scope.row)"
                    type="text"
                    size="mini"
                    >发布</el-button
                  >
                  <el-button
                    v-access:modify
                    v-if="cancel(scope.row)"
                    @click="innerCancel(scope.row)"
                    type="text"
                    size="mini"
                    >取消发布</el-button
                  >
                  <el-button
                    v-access:delete
                    v-if="edit(scope.row)"
                    @click="innerDel(scope.row)"
                    type="text"
                    size="mini"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="讲座培训活动" name="lecture">
            <el-table
              border
              hightlight-current-row
              style="width: 100%"
              :header-cell-class-name="headerRow"
              :data="lectureModel"
              :max-height="tableMaxHeight()"
              v-loading="isloading"
            >
              <el-table-column
                prop="Title"
                label="培训主题"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="LectureType"
                label="讲座类型"
                align="center"
                width="90"
                :formatter="formatterLectureType"
              ></el-table-column>
              <el-table-column
                prop="Contacts"
                label="联系人"
                align="center"
                width="110"
              ></el-table-column>
              <el-table-column
                prop="Phone"
                label="联系电话"
                align="center"
                width="140"
              ></el-table-column>
              <el-table-column
                prop="Status"
                label="发布状态"
                align="center"
                :formatter="formatterStatus"
                width="90"
              ></el-table-column>
              <el-table-column
                prop="CreateTime"
                label="发布时间"
                align="center"
                width="140"
              >
                <template slot-scope="scope">
                  {{ (scope.row.CreateTime * 1000) | formatDate }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="180" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-access:modify
                    v-if="edit(scope.row)"
                    @click="innerEdit(scope.row)"
                    type="text"
                    size="mini"
                    >编辑</el-button
                  >
                  <el-button
                    v-access:read
                    v-if="!approve(scope.row)"
                    @click="innerRead(scope.row)"
                    type="text"
                    size="mini"
                    >详情</el-button
                  >
                  <el-button
                    v-access:modify
                    v-if="approve(scope.row)"
                    @click="innerReview(scope.row)"
                    type="text"
                    size="mini"
                    >送审</el-button
                  >
                  <el-button
                    v-access:modify
                    v-if="release(scope.row)"
                    @click="innerRelease(scope.row)"
                    type="text"
                    size="mini"
                    >发布</el-button
                  >
                  <el-button
                    v-access:modify
                    v-if="cancel(scope.row)"
                    @click="innerCancel(scope.row)"
                    type="text"
                    size="mini"
                    >取消发布</el-button
                  >
                  <el-button
                    v-access:delete
                    v-if="edit(scope.row)"
                    @click="innerDel(scope.row)"
                    type="text"
                    size="mini"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="体验馆预约活动" name="experiencePavilion">
            <el-table
              border
              hightlight-current-row
              style="width: 100%"
              :header-cell-class-name="headerRow"
              :data="experiencePavilionModel"
              :max-height="tableMaxHeight()"
              v-loading="isloading"
            >
              <el-table-column
                prop="Title"
                label="标题"
                width="250"
                align="left"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="Address"
                label="地址"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="Condition"
                label="报名条件"
                width="250"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="NumEach"
                label="每期人数"
                width="90"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="CreateTime"
                label="发布时间"
                width="140"
                align="center"
              >
                <template slot-scope="scope">
                  {{ (scope.row.CreateTime * 1000) | formatDate }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-access:modify
                    @click="innerEdit(scope.row)"
                    type="text"
                    size="mini"
                    >编辑</el-button
                  >
                  <el-button
                    v-access:modify
                    v-if="release(scope.row)"
                    @click="innerRelease(scope.row)"
                    type="text"
                    size="mini"
                    >发布</el-button
                  >
                  <el-button
                    v-access:modify
                    v-if="!release(scope.row)"
                    @click="innerCancel(scope.row)"
                    type="text"
                    size="mini"
                    >取消发布</el-button
                  >
                  <el-button
                    v-access:delete
                    @click="innerDel(scope.row)"
                    type="text"
                    size="mini"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </div>
    </BasePage>
    <ModuleEdit_lifeGuard
      v-if="formVisible_lifeGuard"
      :id="id"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleEdit_lifeGuard>
    <ModuleEdit_lecture
      v-if="formVisible_lecture"
      :id="id"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleEdit_lecture>
    <ModuleEdit_experiencePavilion
      v-if="formVisible_experiencePavilion"
      :id="id"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleEdit_experiencePavilion>
    <ModuleQuery_lifeGuard
      v-if="formDataQuery_lifeGuard"
      :id="id"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleQuery_lifeGuard>
    <ModuleDataQuery_lecture
      v-if="formDataQuery_lecture"
      :id="id"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleDataQuery_lecture>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import ModuleEdit_lifeGuard from "@/modules/zjrc/pages/train/train/edit_lifeGuard";
import ModuleQuery_lifeGuard from "@/modules/zjrc/pages/train/train/query_lifeGuard";
import ModuleEdit_lecture from "@/modules/zjrc/pages/train/train/edit_lecture";
import ModuleDataQuery_lecture from "@/modules/zjrc/pages/train/train/query_lecture";
import ModuleEdit_experiencePavilion from "@/modules/zjrc/pages/train/train/edit_experiencePavilion";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import { mapGetters } from "vuex";
import api from "@/modules/zjrc/api";

export default {
  name: "list",
  data() {
    return {
      headerRow: "header-row",
      isloading: false,
      formVisible_lifeGuard: false,
      formVisible_lecture: false,
      formVisible_experiencePavilion: false,
      formDataQuery_lifeGuard: false,
      formDataQuery_lecture: false,
      formTitle: "",
      formData: {},
      total: 0,
      currentPage: 1,
      pageSize: 15,
      searchModel: { searchKey: "" },
      placeholder: "请输入培训主题",
      activeName: "lifeGuard",
      type: 1, //活动类型
      lifeGuardModel: [], //救护员培训活动
      lectureModel: [], //讲座培训活动
      experiencePavilionModel: [], //体验馆预约活动,
      id: "", //主键Id
    };
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
    approve() {
      return (rowData) => {
        return rowData.ReviewStatus == 0 ? true : false;
      };
    },
    release() {
      return (rowData) => {
        return rowData.ReviewStatus == 2 ? true : false;
      };
    },
    cancel() {
      return (rowData) => {
        return rowData.ReviewStatus == 3 ? true : false;
      };
    },
    edit() {
      return (rowData) => {
        return rowData.ReviewStatus == 0 || rowData.ReviewStatus == 2
          ? true
          : false;
      };
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    search(){
      const vm = this
      vm.currentPage = 1
      vm.loadData()
    },
    //初始化数据
    loadData() {
      this.isloading = true;
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        Type: this.type,
        searchKey: this.searchModel.searchKey,
      };
      api.QueryTrainByType(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          let listData = rep.data.Data.rows;
          switch (this.type) {
            case 1:
              this.lifeGuardModel = listData;
              break;
            case 2:
              this.lectureModel = listData;
              break;
            default:
              this.experiencePavilionModel = listData;
          }
        }
        this.isloading = false;
      });
    },
    formCallBack(data) {
      this.formVisible_lifeGuard = false;
      this.formVisible_lecture = false;
      this.formDataQuery_lifeGuard = false;
      this.formDataQuery_lecture = false;
      this.formVisible_experiencePavilion = false;
      if (data != null) {
        this.loadData();
      }
    },
    //改变分页大小
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.loadData();
    },
    //改变当前页码
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    //列表高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
    //状态
    formatterStatus(item) {
      switch (item.ReviewStatus) {
        case 0:
          return "草稿";
        case 1:
          return "审核中";
        case 2:
          return "已审核";
        case 3:
          return "已发布";
      }
    },
    //讲座类型
    formatterLectureType(item) {
      switch (item.LectureType) {
        case 0:
          return "公益";
        case 1:
          return "收费";
      }
    },
    //新增
    add() {
      this.id = null;
      switch (this.type) {
        case 1:
          this.formVisible_lifeGuard = true;
          this.formTitle = "新增救护员培训活动";
          break;
        case 2:
          this.formVisible_lecture = true;
          this.formTitle = "新增讲座培训活动";
          break;
        default:
          this.formVisible_experiencePavilion = true;
          this.formTitle = "新增体验馆预约活动";
      }
      this.formData = {};
    },
    //编辑
    innerEdit(rowData) {
      this.id = rowData.Id;
      switch (this.type) {
        case 1:
          this.formVisible_lifeGuard = true;
          this.formTitle = "编辑救护员培训活动";
          break;
        case 2:
          this.formVisible_lecture = true;
          this.formTitle = "编辑讲座培训活动";
          break;
        default:
          this.formVisible_experiencePavilion = true;
          this.formTitle = "编辑体验馆预约活动";
      }
    },
    //送审
    innerReview(rowData) {
      this.$confirm("请确认是否送审选中的数据？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = Object.assign({}, rowData);
        params.ProcName =
          params.Type == 2 ? "收费讲座培训审核" : "救护培训活动审核";
        params.Creator = this.GetCurrentUserInfo.RealName;
        params.CreatId = this.GetCurrentUserInfo.Id;
        api.ForReviewTrain(params).then((rep) => {
          if (rep.data.Code === 0) {
            this.$message({
              message: "送审成功",
              type: "success",
            });
            this.loadData();
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            });
          }
        });
      });
    },
    //发布
    innerRelease(rowData) {
      this.$confirm("请确认是否发布选中的数据？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { Id: rowData.Id, ReviewStatus: 3 };
        api.UpdateTrainStatus(params).then((rep) => {
          if (rep.data.Code === 0) {
            this.$message({
              message: "发布成功",
              type: "success",
            });
            this.loadData();
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            });
          }
        });
      });
    },
    //取消发布
    innerCancel(rowData) {
      this.$confirm("请确认是否取消发布选中的数据？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { Id: rowData.Id, ReviewStatus: 2 };
        api.UpdateTrainStatus(params).then((rep) => {
          if (rep.data.Code === 0) {
            this.$message({
              message: "取消发布成功",
              type: "success",
            });
            this.loadData();
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            });
          }
        });
      });
    },
    //查看
    innerRead(rowData) {
      this.id = rowData.Id;
      switch (this.type) {
        case 1:
          this.formDataQuery_lifeGuard = true;
          this.formTitle = "查看救护员培训活动";
          break;
        case 2:
          this.formDataQuery_lecture = true;
          this.formTitle = "查看讲座培训活动";
          break;
      }
    },
    //删除
    innerDel(rowData) {
      this.$confirm("请确认是否删除选中的数据？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { Id: rowData.Id };
        api.DeleteTrainById(params).then((rep) => {
          if (rep.data.Code === 0) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.loadData();
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            });
          }
        });
      });
    },
    //tab切换
    handleTabsClick(tab, event) {
      switch (tab.name) {
        case "lifeGuard":
          this.type = 1;
          break;
        case "lecture":
          this.type = 2;
          break;
        default:
          this.type = 3;
      }
      this.loadData();
    },
  },
  components: {
    BasePage,
    OfSearch,
    OfPagination,
    ModuleEdit_lifeGuard,
    ModuleEdit_lecture,
    ModuleEdit_experiencePavilion,
    ModuleQuery_lifeGuard,
    ModuleDataQuery_lecture,
  },
};
</script>

<style scoped>
.list-form {
  padding: 20px;
  /* border-right: solid 1px #efefef; */
  box-sizing: border-box;
  float: left;
  overflow: auto;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}
/* .el-date-editor >>> .el-input__inner {
  padding-left: 10px !important;
} */

.el-select >>> .el-input__inner {
  width: 3rem;
}

/* .el-date-editor >>> .el-input__inner {
  width: 60%;
} */
.el-row >>> .el-date-editor {
  width: 2.5rem !important;
}
</style>
